import { Box, Tooltip, Typography, useTheme } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { round } from '../../../special/round';
import { tokens } from '../../../../global/theme/tokens';

const OpenAmountBadge = ({ item }) => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode, theme.palette.colorTheme);
  const { t } = useTranslation();

  if (item?.billedAmount == null || item?.totalAmount == null) return null;

  const isPercent =
    item.type === 'hoaiPhase' ||
    item.type === 'percent' ||
    item.type === 'percentEditable';

  const isConverted =
    item.orderedPrice && item.orderedPrice !== item.price && !isPercent;

  let openAmount;
  if (isPercent) {
    openAmount = round(
      (item.totalAmount - item.billedAmount - item.amount) * 100,
      4,
    );
  } else if (isConverted) {
    // Converted positions store `amount` as a flat 1 and `price` as the open
    // monetary value. Convert back to original units using orderedPrice.
    const currentAmountInOriginalUnits =
      item.orderedPrice != 0 ? (item.amount * item.price) / item.orderedPrice : 0;
    openAmount = round(
      item.totalAmount - item.billedAmount - currentAmountInOriginalUnits,
      4,
    );
  } else {
    openAmount = round(item.totalAmount - item.billedAmount - item.amount, 4);
  }

  if (!(openAmount || openAmount === 0)) return null;

  return (
    <Box className="p-1">
      <Tooltip title={t('Open quantity')}>
        <Typography
          fontWeight={600}
          color={
            openAmount == 0
              ? colors.grey[600]
              : openAmount < 0
                ? colors.error
                : colors.success
          }
        >
          {isPercent ? openAmount + '%' : openAmount}
        </Typography>
      </Tooltip>
    </Box>
  );
};

export default OpenAmountBadge;
